import { PageLoader } from 'components/page-loader.js';
import { SearchBarMainEntry } from 'components/search-bar/search-bar-entry.js';
import { SearchOverlay } from 'components/search-overlay/search-overlay.js';
import { DomRefProvider } from 'page-context/domRef/domRefProvider.js';
import { StickyPositionProvider } from 'page-context/scrollStickyStateProvider/scrollStickyMain.js';
import { ReactNode, useEffect } from 'react';
import { STICKY_BAR_APP_CONTAINER } from 'utilities/consts.js';
import { getDocument } from 'utilities/window.js';

export const MainContent = ({ children }: { children?: ReactNode }) => {
  useEffect(() => {
    getDocument()?.querySelector?.('.InitialPageLoader')?.classList.remove('InitialPageLoader');
  }, []);

  return (
    <>
      <DomRefProvider>
        {/** Provides positioning for appbar / secondary bar and scrolliong to hash tags */}
        <StickyPositionProvider>
          <PageLoader>
            <div className="App-container" data-module="appDom" id={STICKY_BAR_APP_CONTAINER}>
              {/** Dynamic Search bar that scrolls with user */}
              <SearchBarMainEntry />
              {children}
            </div>
          </PageLoader>
          <SearchOverlay />
        </StickyPositionProvider>
      </DomRefProvider>
    </>
  );
};
